export const URL = 'https://woper.net/admin/api/v3';
